export default __webpack_public_path__ + "static/media/ic-planner.cd4d2425.svg";